/**
 * @generated SignedSource<<d37be62ad702052dd574dd24a3f3549f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSiteInput = {
  id: string;
  timeZoneId?: string | null | undefined;
};
export type SitesUpdateSiteMutation$variables = {
  input: ReadonlyArray<UpdateSiteInput>;
};
export type SitesUpdateSiteMutation$data = {
  readonly updateSite: {
    readonly siteNode: ReadonlyArray<{
      readonly id: string;
      readonly timeZone: {
        readonly name: string | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  };
};
export type SitesUpdateSiteMutation = {
  response: SitesUpdateSiteMutation$data;
  variables: SitesUpdateSiteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SitesUpdateSiteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSitePayload",
        "kind": "LinkedField",
        "name": "updateSite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "siteNode",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeZoneNode",
                "kind": "LinkedField",
                "name": "timeZone",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SitesUpdateSiteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateSitePayload",
        "kind": "LinkedField",
        "name": "updateSite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SiteNode",
            "kind": "LinkedField",
            "name": "siteNode",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TimeZoneNode",
                "kind": "LinkedField",
                "name": "timeZone",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2cd85bcb197df16e5956fd4b284567af",
    "id": null,
    "metadata": {},
    "name": "SitesUpdateSiteMutation",
    "operationKind": "mutation",
    "text": "mutation SitesUpdateSiteMutation(\n  $input: [UpdateSiteInput!]!\n) {\n  updateSite(input: $input) {\n    siteNode {\n      id\n      timeZone {\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bc648657b948bdb0395e84df0813d6ee";

export default node;
